import { useGetDataService } from './useDataService';

export const useGetQueryCacheData = <T>(url: string, overrideQueryKey?: string) => {
  const { data } = useGetDataService<T>({ url, overrideQueryKey, enabled: false });
  return data;
};
